export default {
  title: 'Impostazioni',
  fields: {
    discount_type: {
      label: 'Tipo di sconto',
    },
  },
  buttons: {
    save: 'Salva',
    cancel: 'Annulla',
  },
  toasts: {
    update_successful: 'Aggiornato con successo',
    updated_failed: 'Aggiornamento non riuscito',
  },
};
